export type Position = {
  latitude: number;
  longitude: number;
};

class PositionProvider {
  getCurrentPosition(): Promise<Position> {
    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => resolve(coords),
        reject
      )
    );
  }
}

const positionProvider = new PositionProvider();

export default positionProvider;
